import { memo } from 'react';

import { SmileIcon } from '@air/design-icons';

import { NullState } from '~/components/NullState';

export const NotificationEmpty = memo(() => (
  <NullState
    className="pt-16 md:pt-16"
    headingAs="h2"
    icon={SmileIcon}
    testId="NOTIFICATIONS_NONE"
    title="You’re all caught up"
    description="You’ll be notified here for @mentions, updates to boards that you follow, and any share links you’ve created."
  />
));

NotificationEmpty.displayName = 'NotificationEmpty';
